import React from 'react';
import FontAwesome from 'react-fontawesome';

class Contact extends React.Component {
	render () {
		return (
			<section id="contact" className="section u-pt" name="contact">
				<div className="container">
					<div className="row">
						<div className="sm-12 col">
							<h2 className="heading--primary">Contact</h2>
						</div>
						<div className="sm-12 col u-text--center u-mv+">
							<a className="contact__email" href="mailto:francislanglois@gmail.com">francis.langlois@gmail.com</a>
						</div>
						<div className="sm-12 col">
							<ul className="u-text--center u-p0">
								<li className="contact__social-icons u-mr"><a href="https://github.com/francislanglois" target="_blank" rel="noopener noreferrer"><FontAwesome name='github-square' /></a></li>
								<li className="contact__social-icons u-mr"><a href="https://www.linkedin.com/in/langloisfrancis/" target="_blank" rel="noopener noreferrer"><FontAwesome name='linkedin-square' /></a></li>
								<li className="contact__social-icons"><a href="https://fb.me/frankycodes" target="_blank" rel="noopener noreferrer"><FontAwesome name='facebook-square' /></a></li>
							</ul>
						</div>
					</div>
				</div>
		</section>
		)
	}
}

export default Contact;


// WEBPACK FOOTER //
// ./src/components/Contact.js